// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { LayerOutput } from "./LayerOutput";
import {
  LayerOutputFromJSON,
  LayerOutputFromJSONTyped,
  LayerOutputToJSON,
  LayerOutputToJSONTyped,
} from "./LayerOutput";
import type { LayersInner1 } from "./LayersInner1";
import {
  LayersInner1FromJSON,
  LayersInner1FromJSONTyped,
  LayersInner1ToJSON,
  LayersInner1ToJSONTyped,
} from "./LayersInner1";

/**
 *
 * @export
 * @interface PublicationMap
 */
export interface PublicationMap {
  /**
   * Semantic ID to link comments across versions
   */
  mapId: number;
  /**
   *
   */
  name: string;
  /**
   *
   */
  layers?: Array<LayersInner1>;
  /**
   *
   */
  studyArea?: LayerOutput | null;
}

/**
 * Check if a given object implements the PublicationMap interface.
 */
export function instanceOfPublicationMap(value: object): value is PublicationMap {
  if (
    (!("mapId" in (value as Record<string, any>)) &&
      !("map_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["mapId"] === undefined &&
      (value as Record<string, any>)["map_id"] === undefined)
  )
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function PublicationMapFromJSON(json: any): PublicationMap {
  return PublicationMapFromJSONTyped(json, false);
}

export function PublicationMapFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PublicationMap {
  if (json == null) {
    return json;
  }
  return {
    mapId: json["map_id"],
    name: json["name"],
    layers:
      json["layers"] == null ? undefined : (json["layers"] as Array<any>).map(LayersInner1FromJSON),
    studyArea:
      json["study_area"] === undefined
        ? undefined
        : json["study_area"] === null
        ? null
        : LayerOutputFromJSON(json["study_area"]),
  };
}

export function PublicationMapToJSON(json: any): PublicationMap {
  return PublicationMapToJSONTyped(json, false);
}

export function PublicationMapToJSONTyped(
  value?: PublicationMap | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    map_id: value["mapId"],
    name: value["name"],
    layers:
      value["layers"] == null ? undefined : (value["layers"] as Array<any>).map(LayersInner1ToJSON),
    study_area: LayerOutputToJSON(value["studyArea"]),
  };
}
